import { atom, useAtom } from 'jotai';

const currentSafeIdAtom = atom<string>('');
const currentParentSafeIdAtom = atom<string>('');

export const useSidebarState = () => {
  const [currentSafeId, setCurrentSafeId] = useAtom(currentSafeIdAtom);
  const [currentParentSafeId, setCurrentParentSafeId] = useAtom(currentParentSafeIdAtom);

  return {
    currentSafeId,
    setCurrentSafeId,
    currentParentSafeId,
    setCurrentParentSafeId,
  };
};
